/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import GlobalModel from 'echarts/types/src/model/Global';
import ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';
import WordCloudSeries from './WordCloudSeries';

export default function normalLayout(ecModel: GlobalModel, api: ExtensionAPI) {
  // eslint-disable-next-line func-names
  ecModel.eachSeriesByType('wordCloud', function (wordCloudModel: WordCloudSeries) {
    const layoutConfig = wordCloudModel.get('layout');
    const { precision, mask, fillMode } = layoutConfig;
    // ...
  });
}
